import {observable, action} from 'mobx';
class Test{
    @observable test = 'null';

    @action abc(){

    }
}
const test = new Test();
export default test